import store from '@/store';
import request from '@/utils/request';

export function getorderlist(data) {
	return request({
		url: 'user/get-order-list',
		method: 'get',
		params: data,
	});
}

export function preview(data) {
	return request({
		url: 'order/preview',
		method: 'post',
		data: data,
	});
}

export function previewOneKey (data) {
	// console.log(store.getters.location)
	const location = store.getters.location
	// const url = `order/preview-by-one-key`
	return request({
    url: 'order/preview-by-one-key',
    method: 'post',
    data: data,
    params: {
			lat: location.lat,
			lng: location.lng
    }
  })
}

export function orderDdd(data) {
	return request({
		url: '/order/add',
		method: 'post',
		data,
	});
}

export function getOrderinfo(data) {
	return request({
		url: 'user/get-order-info',
		method: 'get',
		params: data,
	});
}

export function payDopay(data) {
	return request({
		url: '/pay/dopay',
		method: 'post',
		data,
	});
}

export function cancelorder(data) {
	return request({
		url: 'user/cancel-order',
		method: 'post',
		data: data,
	});
}

export function confirmOrder(data) {
	return request({
		url: 'user/confirm-order',
		method: 'post',
		data: data,
	});
}

export function repay(data) {
	return request({
		url: '/order/repay',
		method: 'post',
		data,
	});
}

export function addOrderApi(data) {
  return request({
    url: '/order/add-order',
    method: 'post',
    data
  })
}

export function addOrderApi_V2 (data) {
  return request({
    url: '/order/add-order-v2',
    method: 'post',
    data	
  })
}

export function getOrderPayInfoApi (data) {
  return request({
    url: '/order/get-order-pay-info',
    method: 'post',
    data
  })	
}

export function payOrderApi (data) {
  return request({
    url: '/order/pay-order',
    method: 'post',
    data
  })
}

export function payAgainApi(data) {
  return request({
    url: '/order/pay-again',
    method: 'post',
    data
  })
}